import Vue from 'vue'
import Router from 'vue-router'

const Login = resolve => require(['@/components/branch/login'], resolve)
const DataGovern = resolve => require(['@/components/branch/data-govern'], resolve)
const PlanGovern = resolve => require(['@/components/branch/plan-govern'], resolve)
const EditPlan = resolve => require(['@/components/branch/edit-plan'], resolve)
const SubCustomer = resolve => require(['@/components/branch/sub-customer'], resolve)
const SubCusBalance = resolve => require(['@/components/branch/sub-cus-balance'], resolve)

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/dataGovern',
      name: 'dataGovern',
      component: DataGovern
    },
    {
      path: '/planGovern',
      name: 'planGovern',
      meta: {
        requireAuth: true
      },
      component: PlanGovern
    },
    {
      path: '/editPlan',
      name: 'editPlan',
      meta: {
        requireAuth: true
      },
      component: EditPlan
    },
    {
      path: '/subCustomer',
      name: 'subCustomer',
      meta: {
        requireAuth: true
      },
      component: SubCustomer
    },
    {
      path: '/subCusBalance',
      name: 'subCusBalance',
      meta: {
        requireAuth: true
      },
      component: SubCusBalance
    }
  ]
})

// 判断是否需要登录权限 以及是否登录
// router.beforeEach((to, from, next) => {
//   if (to.matched.some(res => res.meta.requireAuth)) { // 判断是否需要登录权限
//     if (localStorage.getItem('username')) { // 判断是否登录
//       next()
//     } else { // 没登录则跳转到登录界面
//       next({
//         path: '/HelloWorld',
//         query: { redirect: to.fullPath }
//       })
//     }
//   } else {
//     next()
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js